import { Modal, Image, useWindowDimensions } from 'react-native';
import { Typography, Flex } from '@banhala/ui-kit';

interface SimpleGuidePopupProps {
  visible: boolean;
  imageUrl: string;
  onClose: () => void;
}

export const SimpleGuidePopup = ({
  visible,
  imageUrl,
  onClose,
}: SimpleGuidePopupProps) => {
  const { width: screenWidth } = useWindowDimensions();
  // Android: min(360.dp, maxWidth)
  const modalWidth = Math.min(360, screenWidth - 48);

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      {/* Backdrop */}
      <Flex.Center
        flex={1}
        backgroundColor="alpha_dark40"
        onPress={onClose}
      >
        {/* Content Container - Android: RoundedCornerShape(6.dp), bgAlwaysWhite */}
        <Flex.Column
          width={modalWidth}
          backgroundColor="bg_always_white"
          borderRadius={6}
          overflow="hidden"
          onPress={() => {}} // Prevent backdrop close
        >
          {/* Image - Android: fillMaxWidth, ContentScale.FillWidth */}
          <Image
            source={{ uri: imageUrl }}
            style={{
              width: '100%',
              aspectRatio: 1,
            }}
            resizeMode="cover"
          />

          {/* Button - Android: X_LARGE style, GRAY color */}
          <Flex padding={{ horizontal: 16, vertical: 16 }}>
            <Flex.Center
              height={56}
              borderRadius={8}
              backgroundColor="gray70"
              onPress={onClose}
            >
              <Typography type="h5" color="content_always_white">
                확인
              </Typography>
            </Flex.Center>
          </Flex>
        </Flex.Column>
      </Flex.Center>
    </Modal>
  );
};
